import React from 'react';

const PerformanceChartCard = () => {
    // Placeholder data for the legend based on the image
    const legendData = [
        { label: 'Faible', colorClass: 'faible' },
        { label: 'Bien', colorClass: 'bien' },
        { label: 'Tres bien', colorClass: 'tres-bien' },
    ];

    return (
        <div className="performance-chart-card">
            <div className="card-title">Aujourd'hui</div>
            <div className="chart-container">
                {/* Placeholder for the actual chart component */}
                <div className="chart-placeholder"></div>
            </div>
            <div className="chart-legend">
                {legendData.map(item => (
                    <div key={item.label} className={`legend-item ${item.colorClass}`}>
                        <span className="legend-color"></span>
                        <span>{item.label}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PerformanceChartCard; 